import React from 'react';
import PropTypes from 'prop-types';

const getViewBox = (name) => {
  switch (name) {
    case 'compare':
      return '0 0 26 26';
    case 'search':
      return '0 0 18 18';
    case 'comment':
      return '0 0 19 18';
    case 'chevron':
      return '0 0 8 12';
    case 'check':
      return '0 0 24 24';
    case 'circle':
      return '0 0 24 24';
    case 'circle--check':
      return '0 0 24 24';
    case 'circle--plus':
      return '0 0 24 24';
    case 'location':
      return '0 0 14 20';
    case 'message':
      return '0 0 22 18';
    case 'message--fill':
      return '0 0 22 18';
    case 'arrow--left':
      return '0 0 16 16';
    case 'arrow--right':
      return '0 0 16 16';
    case 'arrow--down':
      return '0 0 16 16';
    case 'mobile':
      return '0 0 15 20';
    case 'hr':
      return '0 0 22 22';
    case 'cloud':
      return '0 0 27 17';
    case 'close':
      return '0 0 14 14';
    case 'check2':
      return '0 0 15 12';
    case 'puzzle-double':
      return '0 0 37 18';
    case 'puzzle':
      return '0 0 18 18';
    case 'categories':
      return '0 0 17 17';
    case 'linkout':
      return '0 0 17 17';
    case 'star':
      return '0 0 18 17';
    case 'star-fill':
      return '0 0 18 17';
    case 'star-fill-2-defs':
      return '0 0 18 17';
    case 'star-fill-2':
      return '0 0 18 17';
    case 'server':
      return '0 0 17 14';
    case 'computer':
      return '0 0 17 16';
    case 'telephone':
      return '0 0 18 18';
    case 'calendar':
      return '0 0 18 20';
    case 'avatar':
      return '0 0 21 21';
    case 'robot':
      return '0 0 25 21';
    case 'trophy':
      return '0 0 18 20';
    case 'facebook':
      return '0 0 7 14';
    case 'linkedin':
      return '0 0 14 13';
    case 'instagram':
      return '0 0 14 14';
    case 'bin':
      return '0 0 17 20';
    case 'apple':
      return '0 0 20 24';
    case 'android':
      return '0 0 21 24';

    default:
      return '0 0 32 32';
  }
};

const getPath = (name, props) => {
  const { fill } = props;

  switch (name) {
    case 'compare':
      return (
        <g transform="translate(0,9)">
          <path
            {...props}
            d="M7.295.705a.998.998 0 0 0 0 1.41L12.17 7H1a1 1 0 1 0 0 2h11.17l-4.876 4.884a.997.997 0 1 0 1.41 1.41l7.296-7.294L8.705.705a.997.997 0 0 0-1.41 0z"
          />
          <path
            {...props}
            transform="matrix(-1 0 0 1 26 -9)"
            d="M7.295.705a.998.998 0 0 0 0 1.41L12.17 7H1a1 1 0 1 0 0 2h11.17l-4.876 4.884a.997.997 0 1 0 1.41 1.41l7.296-7.294L8.705.705a.997.997 0 0 0-1.41 0z"
          />
        </g>
      );
    case 'search':
      return (
        <path
          {...props}
          d="M11.71 11l-.28-.27A6.471 6.471 0 0 0 13 6.5 6.5 6.5 0 1 0 6.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l4.293 4.284a1 1 0 0 0 1.413 0l.078-.078a1 1 0 0 0 0-1.413L12.5 11h-.79zM2 6.5C2 4.01 4.01 2 6.5 2S11 4.01 11 6.5 8.99 11 6.5 11 2 8.99 2 6.5z"
        />
      );
    case 'comment':
      return (
        <g transform="translate(-3 -3)">
          <path
            {...props}
            d="M10 18a1 1 0 0 1 0-2h7.414L20 18.586V6a1 1 0 0 1 2 0v12.586A2 2 0 0 1 18.586 20l-2-2H10zm8-14v9c0 .55-.45 1-1 1H7l-2.59 2.59c-.776.776-1.41.512-1.41-.596V4c0-.55.45-1 1-1h13c.55 0 1 .45 1 1zM6.172 12H16V5H5v8.172L6.172 12z"
          />
        </g>
      );
    case 'chevron':
      return (
        <g
          stroke="none"
          fill="none"
          transform="translate(-8.000000, -6.000000)"
        >
          <path
            {...props}
            d="M8.705,6.705 L8.705,6.705 C8.31551495,7.09448505 8.31517069,7.72585884 8.70423077,8.11576839 L12.58,12 L8.70423077,15.8842316 C8.31517069,16.2741412 8.31551495,16.905515 8.705,17.295 L8.705,17.295 C9.09436075,17.6843607 9.72563925,17.6843607 10.115,17.295 L15.41,12 L10.115,6.705 C9.72563925,6.31563925 9.09436075,6.31563925 8.705,6.705 Z"
          />
        </g>
      );
    case 'check':
      return (
        <path
          {...props}
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm-2.41-8.42l-3.465-3.465a1 1 0 0 0-1.412-.003l-.003.003a.997.997 0 0 0-.002 1.413L9.59 18.41l8.925-9.024a1 1 0 0 0-.004-1.41l-.001-.002a.991.991 0 0 0-1.406.004L9.59 15.58z"
        />
      );
    case 'circle':
      return (
        <path
          {...props}
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z"
        />
      );
    case 'circle--check':
      return (
        <path
          {...props}
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm-2.41-8.42l-3.465-3.465a1 1 0 0 0-1.412-.003l-.003.003a.997.997 0 0 0-.002 1.413L9.59 18.41l8.925-9.024a1 1 0 0 0-.004-1.41l-.001-.002a.991.991 0 0 0-1.406.004L9.59 15.58z"
        />
      );
    case 'circle--plus':
      return (
        <path
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm1-11v5.01c0 .546-.444.99-1 .99a1 1 0 0 1-1-.99V13H5.99A.993.993 0 0 1 5 12a1 1 0 0 1 .99-1H11V5.99c0-.546.444-.99 1-.99a1 1 0 0 1 1 .99V11h5.01c.546 0 .99.444.99 1a1 1 0 0 1-.99 1H13z"
          {...props}
        />
      );
    case 'location':
      return (
        <g transform="translate(-5,-2)">
          <path
            {...props}
            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z"
          />
        </g>
      );
    case 'message':
      return (
        <g transform="translate(-1 -3)">
          <path
            {...props}
            d="M11.97 10.574l5.693-3.43a1 1 0 0 1 1.373.34l.002.003a1 1 0 0 1-.338 1.37l-6.69 4.061-.006.01L5.484 9a1 1 0 0 1 1.032-1.713l5.455 3.287zM4 3h16c1.652 0 3 1.348 3 3v12c0 1.652-1.348 3-3 3H4c-1.652 0-3-1.348-3-3l.01-12c0-1.653 1.338-3 2.99-3zm0 2a.998.998 0 0 0-.99 1L3 18c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V6c0-.548-.452-1-1-1H4z"
          />
        </g>
      );
    case 'message--fill':
      return (
        <g transform="translate(-1 -3)">
          <path
            {...props}
            d="M11.97 10.574L6.517 7.287A1 1 0 0 0 5.484 9l6.52 3.928.006-.01 6.69-4.06a1 1 0 0 0 .338-1.371l-.002-.003a1 1 0 0 0-1.373-.34l-5.692 3.43zM4 3h16c1.652 0 3 1.348 3 3v12c0 1.652-1.348 3-3 3H4c-1.652 0-3-1.348-3-3l.01-12c0-1.653 1.338-3 2.99-3z"
          />
        </g>
      );
    case 'arrow--left':
      return (
        <g transform="translate(-4 -4)">
          <g transform="matrix(-1 0 0 1 24 0)">
            <path
              {...props}
              d="M11.295 4.705a.998.998 0 0 0 0 1.41L16.17 11H5a1 1 0 0 0 0 2h11.17l-4.876 4.884a.997.997 0 1 0 1.41 1.41l7.296-7.294-7.295-7.295a.997.997 0 0 0-1.41 0z"
            />
          </g>
        </g>
      );
    case 'arrow--right':
      return (
        <g transform="translate(-4 -4)">
          <path
            {...props}
            d="M11.295 4.705a.998.998 0 0 0 0 1.41L16.17 11H5a1 1 0 0 0 0 2h11.17l-4.876 4.884a.997.997 0 1 0 1.41 1.41l7.296-7.294-7.295-7.295a.997.997 0 0 0-1.41 0z"
          />
        </g>
      );
    case 'arrow--down':
      return (
        <g transform="translate(-4 -4)">
          <g transform="rotate(90 12 12)">
            <path
              {...props}
              d="M11.295 4.705a.998.998 0 0 0 0 1.41L16.17 11H5a1 1 0 0 0 0 2h11.17l-4.876 4.884a.997.997 0 1 0 1.41 1.41l7.296-7.294-7.295-7.295a.997.997 0 0 0-1.41 0z"
            />
          </g>
        </g>
      );
    case 'mobile':
      return (
        <g stroke="#999" fill="none" fillRule="evenodd" {...props}>
          <rect strokeWidth="2" x="1" y="1" width="13" height="18" rx="2" />
          <rect strokeWidth="2" x="4" y="4" width="7" height="9" rx="1" />
          <path
            {...props}
            d="M7.452 16.5c.28 0 .548-.134.548-.495s-.139-.505-.418-.505c-.28 0-.582.144-.582.505 0 .36.173.495.452.495z"
          />
        </g>
      );
    case 'hr':
      return (
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <circle stroke="#999" strokeWidth="2" cx="10" cy="10" r="10" />
          <path
            d="M7.98 7.07h1.56V14H7.98v-2.94H5.36V14H3.8V7.07h1.56v2.65h2.62V7.07zm5.19-.08c1.04 0 1.837.185 2.39.555.553.37.83.945.83 1.725 0 .487-.112.882-.335 1.185-.223.303-.545.542-.965.715.14.173.287.372.44.595.153.223.305.457.455.7.15.243.295.497.435.76s.27.522.39.775h-1.75l-.385-.69a16.59 16.59 0 0 0-.805-1.305 6.771 6.771 0 0 0-.4-.535h-.77V14h-1.56V7.17c.34-.067.692-.113 1.055-.14.363-.027.688-.04.975-.04zm.09 1.33c-.113 0-.215.003-.305.01l-.255.02v1.88h.44c.587 0 1.007-.073 1.26-.22.253-.147.38-.397.38-.75 0-.34-.128-.582-.385-.725-.257-.143-.635-.215-1.135-.215z"
            fill="#999"
          />
        </g>
      );
    case 'cloud':
      return (
        <path
          d="M21.643 15.894A1.998 1.998 0 0 1 21 16H6a5 5 0 0 1-1.984-9.591A5 5 0 1 1 14 5.999a5 5 0 0 1 9 3.036 3.5 3.5 0 1 1-1.357 6.86z"
          strokeWidth="2"
          strokeLinejoin="bevel"
          {...props}
        />
      );
    case 'close':
      return (
        <g transform="translate(-5 -5)" fill="none" fillRule="evenodd">
          <path
            d="M18.295 5.705a.997.997 0 0 0-1.41 0L12 10.59 7.115 5.705a.997.997 0 1 0-1.41 1.41L10.59 12l-4.885 4.885a.997.997 0 0 0 1.41 1.41L12 13.41l4.885 4.885a.997.997 0 0 0 1.41-1.41L13.41 12l4.885-4.885a.997.997 0 0 0 0-1.41z"
            {...props}
          />
        </g>
      );
    case 'check2':
      return (
        <g transform="translate(-4 -7)" fill="none" fillRule="evenodd">
          <path
            d="M9.59 15.58l-3.465-3.465a1 1 0 0 0-1.412-.003l-.003.003a.997.997 0 0 0-.002 1.413L9.59 18.41l8.925-9.024a1 1 0 0 0-.004-1.41l-.001-.002a.991.991 0 0 0-1.406.004L9.59 15.58z"
            {...props}
          />
        </g>
      );
    case 'puzzle-double':
      return (
        <path
          d="M0 9.268V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8.732a2 2 0 1 0-3.465 0H2a2 2 0 0 1-2-2v-3.268a2 2 0 1 0 0-3.465zM7 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm9 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM19 9.268V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3.268a2 2 0 1 0-3.465 0H21a2 2 0 0 1-2-2v-3.268a2 2 0 1 0 0-3.465zM26 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm9 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
          {...props}
        />
      );
    case 'puzzle':
      return (
        <path
          d="M0 9.268V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8.732a2 2 0 1 0-3.465 0H2a2 2 0 0 1-2-2v-3.268a2 2 0 1 0 0-3.465zM7 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm9 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
          {...props}
        />
      );
    case 'categories':
      return (
        <g stroke="#C2D1D9" strokeWidth="2" fill="none">
          <rect x="1" y="1" width="6" height="6" rx="2" />
          <rect x="10" y="1" width="6" height="6" rx="2" />
          <rect x="10" y="10" width="6" height="6" rx="2" />
          <rect x="1" y="10" width="6" height="6" rx="2" />
        </g>
      );
    case 'linkout':
      return (
        <g>
          <path
            d="M8 0v2H2v13h13V9h2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6z"
            {...props}
          />
          <path
            d="M11.004 0h5.982v6.008a.992.992 0 1 1-1.984 0V3.503L10.05 8.085a.811.811 0 0 1-1.145-.043.86.86 0 0 1 .007-1.178L13.55 2h-2.546a1 1 0 1 1 0-2z"
            {...props}
          />
        </g>
      );
    case 'star':
      return (
        <g transform="translate(-1 -1)">
          <path
            d="M10 15.27l4.151 2.505a1 1 0 0 0 1.49-1.083L14.54 11.97l3.669-3.178a1 1 0 0 0-.57-1.752l-4.829-.41-1.89-4.458a1 1 0 0 0-1.84 0L7.19 6.63l-4.828.41a1 1 0 0 0-.57 1.752L5.46 11.97l-1.102 4.722a1 1 0 0 0 1.491 1.083L10 15.27z"
            {...props}
          />
        </g>
      );
    case 'star-fill':
      return (
        <React.Fragment>
          <defs>
            <path
              d="M10 15.27l4.151 2.505a1 1 0 0 0 1.49-1.083L14.54 11.97l3.669-3.178a1 1 0 0 0-.57-1.752l-4.829-.41-1.89-4.458a1 1 0 0 0-1.84 0L7.19 6.63l-4.828.41a1 1 0 0 0-.57 1.752L5.46 11.97l-1.102 4.722a1 1 0 0 0 1.491 1.083L10 15.27z"
              id="starpath"
            />
          </defs>
          <g transform="translate(-1 -1)">
            <mask id="starmask" fill="#fff">
              <use xlinkHref="#starpath" />
            </mask>
            <use xlinkHref="#starpath" fill="#F1DC35" />
            <g mask="url(#starmask)" fill={props.fill}>
              <path
                d="M0 0h20v19H0z"
                style={{
                  transform: `translateX(${props.offset}px)`,
                  display: 'block',
                }}
              />
            </g>
          </g>
        </React.Fragment>
      );
    case 'star-fill-2-defs':
      return (
        <defs>
          <path
            d="M10 15.27l4.151 2.505a1 1 0 0 0 1.49-1.083L14.54 11.97l3.669-3.178a1 1 0 0 0-.57-1.752l-4.829-.41-1.89-4.458a1 1 0 0 0-1.84 0L7.19 6.63l-4.828.41a1 1 0 0 0-.57 1.752L5.46 11.97l-1.102 4.722a1 1 0 0 0 1.491 1.083L10 15.27z"
            id="starpath2"
          />
        </defs>
      );
    case 'star-fill-2':
      return (
        <g transform="translate(-1 -1)">
          <mask id={`starmask--${props.id}`} fill="#fff">
            <use xlinkHref="#starpath2" />
          </mask>
          <use xlinkHref="#starpath2" fill={props.fillfront} />
          <g mask={`url(#starmask--${props.id})`} fill={props.fillback}>
            <path
              d="M0 0h20v19H0z"
              style={{ transform: `translateX(${props.offset}px)` }}
            />
          </g>
        </g>
      );
    case 'server':
      return (
        <path
          d="M1 8h2V6H1v2zm0 5h2v-2H1v2zM1 3h2V1H1v2zM0 9h17V5H0v4zm0 5h17v-4H0v4zM0 0v4h17V0H0z"
          {...props}
        />
      );
    case 'computer':
      return (
        <path
          d="M10 13v2H7v-2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-5zm-6 2h9v1H4v-1zM2 2v9h13V2H2z"
          {...props}
        />
      );
    case 'telephone':
      return (
        <g transform="translate(-3 -3)">
          <path
            d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
            {...props}
          />
        </g>
      );
    case 'calendar':
      return (
        <g transform="translate(-3 -2)">
          <path
            d="M18 4V3a1 1 0 0 0-2 0v1H8V3a1 1 0 1 0-2 0v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1zM5 20V9h14v11H5zm3-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1z"
            {...props}
          />
        </g>
      );
    case 'avatar':
      return (
        <React.Fragment>
          <defs>
            <path
              d="M2.708 10.292v1.083a.542.542 0 0 1-1.083 0v-1.083c0-1.66 2.617-2.709 4.875-2.709s4.875 1.049 4.875 2.709v1.083a.542.542 0 0 1-1.083 0v-1.083c0-.791-2.083-1.625-3.792-1.625-1.71 0-3.792.834-3.792 1.625zm6.5-6.5a2.708 2.708 0 1 1-5.415 0 2.708 2.708 0 0 1 5.415 0zm-1.083 0a1.624 1.624 0 1 0-3.249-.002 1.624 1.624 0 0 0 3.249.002z"
              id="avatar"
            />
          </defs>
          <g transform="translate(1 1)" fill="none" fillRule="evenodd">
            <circle stroke="#1F2432" cx="9.5" cy="9.5" r="9.5" />
            <g transform="translate(3 3)">
              <mask id="bavatar" fill="#fff">
                <use xlinkHref="#avatar" />
              </mask>
              <use fill="#C2D1D9" fillRule="nonzero" xlinkHref="#avatar" />
              <g mask="url(#bavatar)" fill="#1F2432">
                <path d="M0 0h13v13H0z" />
              </g>
            </g>
          </g>
        </React.Fragment>
      );
    case 'robot':
      return (
        <g
          transform="translate(1 1)"
          stroke={fill || '#777'}
          strokeWidth="1.5"
          fill="none"
          fillRule="evenodd"
        >
          <circle cx="11.346" cy="1.923" r="1.923" />
          <path d="M11.346 3.846v2.308" strokeLinecap="square" />
          <rect x="3" y="6.654" width="16.692" height="12.846" rx="3" />
          <circle cx="6.923" cy="11.731" r="1.346" />
          <circle cx="15.769" cy="11.731" r="1.346" />
          <path
            d="M2.692 10.78C.897 11.347 0 12.244 0 13.472c0 1.228.897 2.126 2.692 2.693M20.091 10.78c1.795.567 2.692 1.464 2.692 2.692 0 1.228-.897 2.126-2.692 2.693M8.695 15.577c1.062.784 1.946 1.175 2.651 1.175.705 0 1.588-.391 2.648-1.175"
            strokeLinecap="square"
          />
        </g>
      );
    case 'trophy':
      return (
        <g stroke={fill || '#777'} fill="none" fillRule="evenodd">
          <path d="M7.629 11.929h3v2.143h-3zM4.706 14.214L3.73 19.5h10.799l-.976-5.286H4.706z" />
          <path d="M14.058 7.5v-7H4.2v7h.024l.085.395a4.93 4.93 0 0 0 9.638 0l.085-.395h.025z" />
          <path
            d="M4.13 2.232C2.042 1.404 1 1.712 1 3.152S2.043 6.315 4.13 8.32V2.232zM14.143 2.232c2.086-.828 3.13-.52 3.13.92s-1.044 3.163-3.13 5.168V2.232z"
            strokeLinecap="square"
          />
        </g>
      );
    case 'facebook':
      return (
        <g transform="translate(-9 -5)" fill="none" fillRule="evenodd">
          <path
            d="M15.253 12.006H13.29V19h-2.908v-6.994H9V9.534h1.382v-1.6c0-1.145.544-2.934 2.935-2.934l2.155.008v2.4h-1.564c-.255 0-.617.127-.617.673v1.453h2.216l-.254 2.472z"
            {...props}
          />
        </g>
      );
    case 'linkedin':
      return (
        <g transform="translate(-5 -6)" fill="none" fillRule="evenodd">
          <path
            d="M18.604 13.97V19h-2.916v-4.693c0-1.179-.421-1.983-1.477-1.983-.806 0-1.285.541-1.496 1.066-.077.187-.097.448-.097.71V19H9.701s.04-7.949 0-8.772h2.917v1.243c-.005.01-.014.02-.019.029h.02v-.029c.387-.596 1.078-1.449 2.628-1.449 1.919 0 3.357 1.254 3.357 3.948zM6.65 6c.998 0 1.611.655 1.63 1.515 0 .842-.632 1.516-1.649 1.516h-.019C5.634 9.031 5 8.357 5 7.515 5 6.655 5.653 6 6.65 6zM5.173 19v-8.772H8.09V19H5.173z"
            {...props}
          />
        </g>
      );
    case 'instagram':
      return (
        <g transform="translate(-5 -5)" fill="none" fillRule="evenodd">
          <path
            d="M19 10.563v5.731A2.708 2.708 0 0 1 16.294 19H7.705A2.708 2.708 0 0 1 5 16.294V7.705A2.708 2.708 0 0 1 7.705 5h8.589A2.708 2.708 0 0 1 19 7.705v2.858zm-7 3.9A2.468 2.468 0 0 0 14.463 12c0-.536-.175-1.031-.466-1.436a2.46 2.46 0 0 0-1.997-1.028c-.823 0-1.55.407-1.999 1.028-.291.404-.465.9-.466 1.436A2.465 2.465 0 0 0 12 14.463zm5.38-5.478V6.612l-.309.001-2.064.007.008 2.373 2.365-.008zm-1.551 3.014a3.833 3.833 0 0 1-3.83 3.83 3.833 3.833 0 0 1-3.828-3.83c0-.507.102-.993.282-1.436h-2.09v5.731c0 .74.602 1.34 1.342 1.34h8.588c.74 0 1.342-.6 1.342-1.34v-5.731h-2.091c.182.443.285.929.285 1.436z"
            {...props}
          />
        </g>
      );
    case 'bin':
      return (
        <path
          d="M1 6h15v11a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6zM6 2v-.5A1.5 1.5 0 0 1 7.5 0h2A1.5 1.5 0 0 1 11 1.5V2h6v2H0V2h6z"
          {...props}
        />
      );
    case 'apple':
      return (
        <path
          d="M18.716 8.182c-.138.108-2.57 1.493-2.57 4.573 0 3.562 3.095 4.822 3.187 4.853-.014.077-.491 1.726-1.631 3.406-1.017 1.479-2.078 2.955-3.693 2.955-1.615 0-2.03-.948-3.895-.948-1.816 0-2.462.979-3.94.979-1.477 0-2.507-1.368-3.692-3.048C1.109 18.979 0 15.914 0 13.005c0-4.667 3.002-7.141 5.956-7.141 1.57 0 2.878 1.041 3.864 1.041.938 0 2.4-1.104 4.187-1.104.676 0 3.108.063 4.709 2.381Zm-5.557-4.356c.738-.886 1.26-2.115 1.26-3.344 0-.17-.013-.343-.044-.482-1.202.046-2.632.809-3.494 1.82-.676.777-1.308 2.006-1.308 3.252 0 .187.03.374.045.434.076.015.2.031.323.031 1.078 0 2.434-.73 3.218-1.711Z"
          {...props}
        />
      );
    case 'android':
      return (
        <g fill="#000" fillRule="nonzero">
          <path
            d="M1.407 7.6c-.392 0-.724.145-.997.435-.273.29-.41.637-.41 1.043v6.23c0 .415.137.768.41 1.057.273.29.605.435.997.435.391 0 .721-.145.99-.435a1.5 1.5 0 0 0 .403-1.057v-6.23c0-.406-.137-.754-.41-1.043a1.304 1.304 0 0 0-.983-.435ZM13.446 2.227 14.46.32c.066-.126.042-.223-.072-.29-.123-.06-.218-.03-.285.086L13.076 2.04a6.897 6.897 0 0 0-2.869-.612 6.896 6.896 0 0 0-2.868.612L6.31.116C6.244 0 6.15-.029 6.026.03c-.114.069-.138.165-.071.291l1.013 1.907a6.301 6.301 0 0 0-2.455 2.235A5.727 5.727 0 0 0 3.6 7.6h13.2c0-1.136-.305-2.18-.913-3.138a6.329 6.329 0 0 0-2.44-2.235ZM7.588 5.001a.53.53 0 0 1-.392.168A.506.506 0 0 1 6.81 5a.564.564 0 0 1-.157-.4c0-.155.052-.289.157-.4a.508.508 0 0 1 .385-.168c.152 0 .283.056.392.167.11.113.165.246.165.4a.554.554 0 0 1-.165.401Zm6.015 0a.507.507 0 0 1-.385.168.53.53 0 0 1-.393-.168.55.55 0 0 1-.164-.4c0-.155.055-.289.164-.4a.53.53 0 0 1 .393-.168c.152 0 .28.056.385.167a.565.565 0 0 1 .157.4.564.564 0 0 1-.157.401ZM3.6 17.635c0 .444.153.82.46 1.128.307.308.68.463 1.122.463h1.064l.014 3.284c0 .415.144.767.432 1.056.287.29.632.434 1.035.434.412 0 .762-.145 1.05-.434.287-.29.43-.641.43-1.056v-3.284h1.985v3.284c0 .415.144.767.432 1.056.287.29.637.434 1.05.434.411 0 .761-.145 1.049-.434.287-.29.431-.641.431-1.056v-3.284h1.079c.431 0 .8-.154 1.107-.463a1.54 1.54 0 0 0 .46-1.128V8H3.6v9.635ZM18.993 7.6c-.382 0-.71.143-.983.427-.273.286-.41.636-.41 1.05v6.23c0 .416.137.769.41 1.058.273.29.6.435.983.435.392 0 .724-.145.997-.435.273-.29.41-.642.41-1.057v-6.23a1.46 1.46 0 0 0-.41-1.05 1.33 1.33 0 0 0-.997-.428Z"
            {...props}
          />
        </g>
      );

    default:
      return <path />;
  }
};

const Icon = ({
  id = '',
  name = '',
  style = {},
  fill = '#000',
  stroke,
  viewBox = '',
  width = '100%',
  className = '',
  height = '100%',
  offset = 0,
  fillfront,
  fillback,
  title,
  role = 'img',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    role={role}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox || getViewBox(name)}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    {title ? <title>{title}</title> : null}
    {getPath(name, { fill, stroke, offset, fillfront, fillback, id })}
  </svg>
);

Icon.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  style: PropTypes.objectOf(PropTypes.string),
  fill: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.string,
};

export default Icon;
